import { motion } from "framer-motion";
import { CONTACT } from "@/lib/i18n";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={`https://wa.me/${CONTACT.whatsappRaw}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.05 }}
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 flex items-center justify-center gap-3 bg-ink-900 text-gold border border-gold/40 px-4 py-3 md:px-5 md:py-4 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.5)] hover:bg-gold hover:text-ink-900 transition-colors"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
    >
      <svg
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="currentColor"
        aria-hidden="true"
        className="shrink-0"
      >
        <path d="M19.05 4.91A10 10 0 0 0 4.1 18.34L3 23l4.79-1.06A10 10 0 1 0 19.05 4.9Zm-7 16.27a8.27 8.27 0 0 1-4.22-1.16l-.3-.18-2.84.63.62-2.77-.2-.32a8.27 8.27 0 1 1 6.94 3.8Zm4.55-6.18-1.7-.79c-.23-.11-.4-.17-.57.11s-.66.79-.81.96-.3.18-.55.06a6.78 6.78 0 0 1-2-1.24 7.46 7.46 0 0 1-1.39-1.72c-.15-.25 0-.39.11-.5s.25-.3.37-.45a1.7 1.7 0 0 0 .25-.41.46.46 0 0 0 0-.43c-.06-.12-.57-1.36-.78-1.86s-.41-.43-.57-.43h-.49a.93.93 0 0 0-.68.32 2.84 2.84 0 0 0-.88 2.1 4.93 4.93 0 0 0 1 2.65 11.19 11.19 0 0 0 4.27 3.78c.6.26 1.07.41 1.43.53a3.46 3.46 0 0 0 1.58.1 2.6 2.6 0 0 0 1.69-1.19 2.07 2.07 0 0 0 .15-1.19c-.06-.11-.22-.17-.45-.28Z" />
      </svg>
      <span className="hidden sm:inline text-[10px] uppercase tracking-[0.3em]">WhatsApp</span>
    </motion.a>
  );
}
